var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/buffer/~/isarray/index.js
// module id = 1786
// module chunks = 2